/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { MyLibraryTeacherCandidateViewModel } from "../types/MyLibraryTeacherCandidateViewModel.ts";

export const myLibraryTeacherCandidateViewModelSchema = z.object({
  personId: z.optional(
    z.number().int().describe("ID da pessoa do corpo docente."),
  ),
  personName: z.string().describe("Nome completo do professor.").nullish(),
  email: z.string().describe("E-mail do professor, em minúsculas.").nullish(),
}) as unknown as ToZod<MyLibraryTeacherCandidateViewModel>;
